import { Component, OnInit }             from '@angular/core';
import { DashboardPanelComponentBase }   from '@cs/components/shared';
import { IndicatorDataDescribed }        from '@cs/components/indicator';
import { ArrayUtils, isNullOrUndefined } from '@cs/core';

@Component({
			   standalone: false,
			   selector:    'cs-dashboard-single-indicators',
			   templateUrl: './dashboard-single-indicators.component.html',
			   styleUrls:   ['./dashboard-single-indicators.component.scss']
		   })
export class DashboardSingleIndicatorsComponent extends DashboardPanelComponentBase<IndicatorDataDescribed> implements OnInit {
	name: string;

	constructor() {
		super();
	}

	ngOnInit() {
	}

	dataChanged(value: IndicatorDataDescribed) {

	}

	update(data: IndicatorDataDescribed): void {
		if (!isNullOrUndefined(this.data) && !isNullOrUndefined(data) &&
			(this.data && ArrayUtils.isEqual(this.data.data, data.data)))
			return;

		this.data = data;
	}

}
